const KEY = 'untitled-academy-course-finder:v1'
const VERSION = 2

export function loadProgress() {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY))
    return parsed?.version === VERSION ? parsed.data : null
  } catch {
    return null
  }
}

export function saveProgress(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ version: VERSION, data, savedAt: new Date().toISOString() }))
    return true
  } catch {
    return false
  }
}

export function clearProgress() {
  try { localStorage.removeItem(KEY) } catch { /* local storage may be disabled */ }
}
